import React from 'react'
import { styled } from 'linaria/react'
import LoadingPage from '../LoadingPage'
import { theme } from '../Theme'
import loadable from '@loadable/component'
import { useLocation } from 'react-router-dom'
import SearchQueryProductList from '../Core/ListComponents/SearchQueryProductList'

const Wrapper = styled.section`
   background-color: ${theme.colors.white};
   padding-bottom: ${theme.spacing.m};
`

const NotFound = loadable(() => import('../NotFoundPage'), {
   fallback: <LoadingPage />,
})

const SearchPage = () => {
   const location = useLocation();
   const urlParams = new URLSearchParams(location?.search);
   const searchValue = urlParams.get("q");

   if (!searchValue?.trim()) {
      return (<NotFound />);
   }

   return (
      <SearchQueryProductList key={searchValue} searchQuery={searchValue} />
   )
}

export default SearchPage